import { DateTime } from 'luxon';

export const formatAggregationBucketDate = (timestamp, aggregation, locale) => {
  if (!timestamp) return null;

  const date = DateTime.fromISO(timestamp);
  if (!date.isValid) return null;

  const localizedDate = date.setLocale(locale === 'dk' ? 'da' : locale);

  switch (aggregation) {
    case 'hour':
      return localizedDate.toLocaleString(DateTime.DATETIME_MED);
    case 'week': {
      const start = localizedDate.startOf('week');
      const end = localizedDate.endOf('week');
      const startDate = start.toLocaleString(DateTime.DATE_MED);
      const endDate = end.toLocaleString(DateTime.DATE_MED);
      return `${startDate} – ${endDate}`;
    }
    case 'month':
      return localizedDate.toLocaleString({ month: 'long', year: 'numeric' });
    case 'day':
    default:
      return localizedDate.toLocaleString(DateTime.DATE_MED);
  }
};
